import React, { Component } from 'react';
import {connect} from 'react-redux'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,ControlLabel,InputGroup,Form,FormGroup,Row,Col,FormControl,Modal,OverlayTrigger,Popover,Tooltip} from 'react-bootstrap'
import Select from 'react-select'
import DatePicker from 'component/element/DatePicker'
import GenDocStore from 'stores/GenDocStore'
import NewContractorModal from '../hr/NewContractorModal'
import EmployeeModal from '../hr/EmployeeModal'
import SupplierPageModal from '../po/SupplierPageModal'
import FontAwsome from 'react-fontawesome'
import { Radio } from 'react-icheck'
import IframeModal from 'component/element/IframeModal'
var NotificationSystem = require('react-notification-system');
class WithholdingTaxDoc extends Component {

  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      showPull:false,
      pullType:'',
      doc:this.initDoc(),
      data:[],
      showSup:false,
      showEmp:false,
      showContractor:false,
      docNo:null,
      form_options:[],
      payer_options:[],
      tax_rate_options:[],
      type_of_income_options:[],
      showPSelect:false,
      pSelect:'0'
    }
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem
  }

  initDoc() {
    return {
      customer_name:"",
      customer_address:"",
      customer_branch:"",
      customer_tax:"",
      customer_id:"",
      withholdingtax_no:"",
      seq_no:"",
      form_id:"",
      status:"",
      amount_exclude_vat:"",
      vat:"",
      amount:"",
      withholding_amount:"",
      payment_amount:"",
      remark:"",
      canceled:"",
      trash_flag:"",
      payment_date:"",
      payment_detail:"",
      payer:"deductTaxWithheld",
      added_date:"",
      created_by:"",
      last_by:"",
      identity_no:"",
      customer_type:"",
      customer_title:"",
      customer_province:"",
      customer_postalcode:"",
      customer_tel:"",
      customer_fax:"",
      customer_credit_day:"",
      customer_detail:"",
      affiliates_id:"",
      added_by:""
    }
  }

  newEmptyRow(number) {
		return new Array(number).fill(null).map((item,index)=>{
      return {
        amount: "",
        bf_withholdingtax_item_id: "",
        detail: "",
        seq: "",
        tax_rate: "",
        type_of_income: "",
        vat_type: "NON_VAT",
        withholdingtax_no: ""
      }
    })
  }

  getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getNumber(value,digit=2) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(digit)
  }

  loadNewDoc() {
    this.setState({loading:true})
    GenDocStore.loadNewWithholdingTaxDoc((result)=>{
      let form_options = result.data.form_options.map((item,index)=>{
        return {label:item.form_id,value:item.form_id}
      })
      let tax_rate_options = result.data.tax_rate_options.map((item,index)=>{
        return {label:item.toString(),value:item.toString()}
      })
      let type_of_income_options = result.data.type_of_income_options.map((item,index)=>{
        return Object.assign(item,{label:item.description,value:item.type_of_income})
      })
      this.setState({loading:false,docNo:result.data.doc.withholdingtax_no,data:result.data.itemlist,doc:result.data.doc,form_options:form_options,payer_options:result.data.payer_options,tax_rate_options:tax_rate_options,type_of_income_options:type_of_income_options})
    },()=>{
      this.setState({loading:false})
    })
  }

  loadData(docNo) {
    this.setState({docNo:docNo,loading:true})
    GenDocStore.loadWithholdingTaxDoc(docNo,(result)=>{
      let form_options = result.data.form_options.map((item,index)=>{
        return {label:item.form_id,value:item.form_id}
      })
      let tax_rate_options = result.data.tax_rate_options.map((item,index)=>{
        return {label:item.toString(),value:item.toString()}
      })
      let type_of_income_options = result.data.type_of_income_options.map((item,index)=>{
        return Object.assign(item,{label:item.description,value:item.type_of_income})
      })
      let data = result.data.itemlist.map((item,index)=>{
        let type_of_income = type_of_income_options.find((element)=> (element.type_of_income*1===item.type_of_income*1))
        
        item.has_detail = (type_of_income)?type_of_income.has_detail*1===1:false
        
        return item
      })
      this.setState({loading:false,data:data,doc:result.data.doc,form_options:form_options,payer_options:result.data.payer_options,tax_rate_options:tax_rate_options,type_of_income_options:type_of_income_options})
    },()=>{
      this.setState({loading:false})
    })
  }

  onRowAdd(number) {
    let {data} = this.state
		data = data.concat(this.newEmptyRow(number))
    this.setState({data:data})
  }

  onPrintClick() {
    let {docNo} = this.state
    this.onSaveClick(()=>{
      if (process.env.NODE_ENV == "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?id=' + docNo + '&file=pdfstatic_doc&dn=withholdingtax_doc', '_blank');
      } else {
        window.open('./pdf/?id=' + docNo + '&file=pdfstatic_doc&dn=withholdingtax_doc', '_blank');
      }
    })
  }

  onTextChange(field,e) {
    let {doc} = this.state
    doc[field] = e.target.value
    this.setState({doc:doc})
  }

  onDateChange(dateString, dateMoment) {
    let {doc} = this.state
    doc['added_date'] = dateString
    this.setState({doc:doc})
  }

  onShowModalClick() {
    this.setState({showPSelect:true})
  }

  onSupSelect(e) {
    let {doc} = this.state
    doc.customer_id = e.shop_id
		doc.customer_name = e.name
		doc.customer_address = e.address
		doc.customer_tax = e.tax_no
		doc.customer_branch = e.branch
    this.setState({doc:doc})
	}

  onEmployeeSelect(e) {
    let {doc} = this.state
    doc.customer_id = e.employee_id
    doc.customer_name = e.first_name+' '+e.last_name
    doc.customer_address = ''
		doc.customer_tax = e.tax_no
		doc.customer_branch = ''
    this.setState({doc:doc})
  }

  onContractorSelect(e) {
    let {doc} = this.state
    doc.customer_id = e.employee_id
    doc.customer_name = e.first_name+' '+e.last_name
    doc.customer_address = ''
		doc.customer_tax = e.tax_no
		doc.customer_branch = ''
    this.setState({doc:doc})
  }

  onFormChange(e) {
    let {doc} = this.state
    doc.form_id = (e?e.value:'')
    this.setState({doc:doc})
  }

  renderTaxNo() {
    let {messages} = this.props
    return(
      <Col md={3}>
          <FormGroup
            controlId={null}
            validationState={null}
          >
            <ControlLabel>{messages['Taxpayer Number']} :</ControlLabel>
            <InputGroup>
              <InputGroup.Addon><FontAwsome name='asterisk'/></InputGroup.Addon>
              <FormControl value={this.state.doc.customer_tax} onChange={this.onTextChange.bind(this,'customer_tax')} />
            </InputGroup>            
          </FormGroup>
        </Col>
    )
  }

  renderHeaderRow(){
		let {messages} = this.props
		let {doc} = this.state
		return (
	   	<div>
	   	  <Row>
	        <Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Customer']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='user'/></InputGroup.Addon>
	              <FormControl value={doc.customer_name} onChange={this.onTextChange.bind(this,'customer_name')} />
	              <InputGroup.Addon style={{cursor:'pointer'}} onClick={this.onShowModalClick.bind(this)}><FontAwsome name='plus'/></InputGroup.Addon>
	            </InputGroup>   
	          </FormGroup>
	        </Col>
	        <Col md={6}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Address']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='location-arrow'/></InputGroup.Addon>
	              <FormControl value={doc.customer_address} onChange={this.onTextChange.bind(this,'customer_address')} />
	            </InputGroup>            
	          </FormGroup>
	        </Col>
	        {this.renderTaxNo()}
	      </Row>
				<Row>
	        <Col md={3}>
	          <FormGroup
	            controlId={null}
	            validationState={null}
	          >
	            <ControlLabel>{messages['Branch']} :</ControlLabel>
	            <InputGroup>
	              <InputGroup.Addon><FontAwsome name='asterisk'/></InputGroup.Addon>
	              <FormControl value={doc.customer_branch} onChange={this.onTextChange.bind(this,'customer_branch')} />
	            </InputGroup>
						</FormGroup>
					</Col>
          <Col md={6}></Col>
          <Col md={3}>
            <FormGroup>
              <ControlLabel>{messages['Date']} :&nbsp;</ControlLabel>
              <DatePicker
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={doc.added_date}
                onChange={this.onDateChange.bind(this)}
                maxWidth={'100%'}
              />
            </FormGroup>
          </Col>
				</Row>
      </div>
    )
  }      

  onFormRowChange(index,field,e) {
    let {data} = this.state
    data[index][field] = (field==='type_of_income'||field==='tax_rate'||field==='vat_type'?e.value:e.target.value)
    if(field==='type_of_income'){
      if(e.has_detail*1===1){
        data[index]['has_detail'] = true
      }else{
        data[index]['has_detail'] = false
      }
    }
    this.setState({data:data})
  }

  onFormRowSelect(index,field,e,item_select) {
    let {data} = this.state
    if (field==='detail') {
      data[index][field] = e
      data[index]['type_of_income'] = item_select.id
    } else if (field==='tax_rate') {
      data[index][field] = item_select.id.toString()
    }
    this.setState({data:data})
  }

  onDelClick(index) {
    let {data} = this.state
    data.splice(index,1)
    this.setState({data:data})
  }

  renderRowData() {
    let {data,type_of_income_options,tax_rate_options} = this.state
    let {messages} = this.props
    if (data.length===0) {
      return(<tr><td colSpan={6}>{messages['Data Not Found']}</td></tr>)
    } else {
      return(
        data.map((item,index)=>{ 
          return(
            <tr key={index}>
              <td className='text-center' style={{verticalAlign:'middle'}}>{index+1}</td>
              <td className='text-left'>
                <Select
                  placeholder={messages['Select']}
                  clearable={false}
                  value={item.type_of_income}
                  options={type_of_income_options}
                  onChange={this.onFormRowChange.bind(this,index,'type_of_income')}
                  clearValueText=''
                />
                {item.has_detail && (
                  <FormControl value={item.detail} onChange={this.onFormRowChange.bind(this,index,'detail')} />
                )}
              </td>
              <td className='text-left'>
                <Select
                  placeholder={messages['Select']}
                  clearable={false}
                  value={item.tax_rate}
                  options={tax_rate_options}
                  onChange={this.onFormRowChange.bind(this,index,'tax_rate')}
                  clearValueText=''
                />
              </td> 
              <td className='text-center'>
                <FormControl className='text-right' value={item.amount} onChange={this.onFormRowChange.bind(this,index,'amount')} />
              </td>
              <td className='text-left' style={{verticalAlign:'middle'}}>
                <Select
                  placeholder={messages['Select']}
                  clearable={false}
                  value={item.vat_type}
                  options={[
                    {label:messages['Exclude Vat'],value:'VAT_EXCLUDE'},
                    {label:messages['Include Vat'],value:'VAT_INCLUDE'},
                    {label:messages['Non Vat'],value:'NON_VAT'}
                  ]}
                  onChange={this.onFormRowChange.bind(this,index,'vat_type')}
                  clearValueText=''
                />
              </td>
              <td className='text-center' style={{verticalAlign:'middle'}}>
                <Button bsStyle='danger' onClick={this.onDelClick.bind(this,index)}><FontAwsome name='trash' /></Button>
              </td>
            </tr>
          )
        })
      )
    }
  }

  getAmountBeforeVat() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount*1)
      if (item.vat_type==='VAT_INCLUDE') {
        let iamount = item.amount/1.07
        sum += iamount
      } else 
        sum += amount
    })
    return sum
  }

  getVat() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let vat = 0
      let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount*1)
      if (item.vat_type==='VAT_INCLUDE') {
        let iamount = item.amount/1.07
        vat = amount-iamount
      } else if (item.vat_type==='VAT_EXCLUDE') {
        vat = (amount*7)/100
      }
      sum += vat
    })
    return sum
  }

  getAmount() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let vat = 0
      let ramount = 0
      let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount*1)
      if (item.vat_type==='VAT_INCLUDE') {
        let iamount = item.amount/1.07
        vat = amount-iamount
        ramount = (iamount+vat)*1
      } else {
        if (item.vat_type==='VAT_EXCLUDE')
          vat = (amount*7)/100
        
        ramount = (amount+vat)*1
      }  
      sum += ramount
    })
    return sum
  }

  getDeductedTax() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let dt = 0
      let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount*1)
      if (item.vat_type==='VAT_INCLUDE') {
        let iamount = item.amount/1.07
        dt = (iamount*item.tax_rate)/100
      } else 
        dt = (amount*item.tax_rate)/100
      
      sum += dt
    })
    return sum
  }

  getPayments() {
    return this.getNumber(this.getAmount())-this.getNumber(this.getDeductedTax())
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='table-responsive'>
	      <table className='table table-hover table-bordered-solid' style={{marginBottom:'0'}}>
	        <thead>
	          <tr>
							<th className='text-center' style={{width:'50px'}}>
								{messages['Number']}
							</th>
              <th className='text-center' style={{width:'500px'}}>
								{messages['Type of income paid']}
							</th>
              <th className='text-center' style={{width:'150px'}}>
								{messages['Deducted tax rate']}
							</th>
              <th className='text-center' style={{width:'100px'}}>
								{messages['Amount']}
							</th>
              <th className='text-center' style={{width:'200px'}}>
								{messages['Vat']}
							</th>
              <th className='text-center' style={{width:'50px'}}>
								{messages['Delete']}
							</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={4} className='text-right'>{messages['Amount']} ({messages['Tax not included']})</th>
              <th className='text-right'>{this.getNumberFormat(this.getAmountBeforeVat())}</th>
              <th></th>
            </tr>
            <tr>
              <th colSpan={4} className='text-right'>{messages['Vat']} 7%</th>
              <th className='text-right'>{this.getNumberFormat(this.getVat())}</th>
              <th></th>
            </tr>
            <tr>
              <th colSpan={4} className='text-right'>{messages['Amount']}</th>
              <th className='text-right'>{this.getNumberFormat(this.getAmount())}</th>
              <th></th>
            </tr>
            <tr>
              <th colSpan={4} className='text-right'>{messages['Deducted tax']}</th>
              <th className='text-right'>{this.getNumberFormat(this.getDeductedTax())}</th>
              <th></th>
            </tr>
            <tr>
              <th colSpan={4} className='text-right'>{messages['Payments']}</th>
              <th className='text-right'>{this.getNumberFormat(this.getPayments())}</th>
              <th></th>
            </tr>
          </tfoot>
        </table>
      </div>        
    )
  }

  onPaymentTaxChange(value,e) {
    let {doc} = this.state
    doc.payer = value
    this.setState({doc:doc})
  }

  renderPayer() {
    let {doc,payer_options} = this.state
    let {messages} = this.props
    return(
      <div className='wh-payee'>
        {messages['Payer']} <br />
        <Form inline>
          <FormGroup>
            {payer_options.map((item,index)=>{
              return(
                <span key={index}>
                  <Radio
                    onChange={this.onPaymentTaxChange.bind(this,item.payer_id)}
                    checked={doc.payer===item.payer_id?true:false}
                    radioClass="iradio_square-blue"
                    increaseArea="20%"
                    label={' '+item.description}
                  >
                  </Radio>
                  {' '}
                </span> 
              ) 
            })}
            <Radio
              onChange={this.onPaymentTaxChange.bind(this,'other')}
              checked={doc.payer==='other'?true:false}
              radioClass="iradio_square-blue"
              increaseArea="20%"
              label={' '+messages['Other']}
            >
            </Radio>
          </FormGroup>
          {' '}
          <FormGroup>
            <FormControl placeholder={messages['Please specify']} value={doc.payment_detail?doc.payment_detail:''} onChange={this.onTextChange.bind(this,'payment_detail')} />
          </FormGroup>
        </Form>
      </div>
    )
  }

  renderRemark() {
    let {messages} = this.props
    return (
	      <Col md={3}>
	        <FormGroup
	          controlId={null}
	          validationState={null}
	        >
	          <ControlLabel>{messages['Note']} </ControlLabel>
	          <FormControl 
								onChange={this.onTextChange.bind(this,'remark')}
								value={this.state.doc.remark} 
								componentClass="textarea"
								rows={5}
								style={{width:'100%'}}
	          />            
	        </FormGroup>
	      </Col>
    )
  }

  renderOtherDetail() {
    let {messages} = this.props
    return (
	      <Col md={9}>
	        <Button bsStyle='link' bsSize='bg' onClick={()=>{}}><FontAwsome name='plus' /> {messages['Add more details']}</Button>
	      </Col>
    )
  }

  onSaveClick(completeSave=()=>{}) {
    let {messages} = this.props
    let {docNo,doc,data} = this.state
    doc.amount_exclude_vat = this.getAmountBeforeVat()
    doc.vat = this.getVat()
    doc.amount = this.getAmount()
    doc.withholding_amount = this.getDeductedTax()
    doc.payment_amount = this.getPayments()
    let postData = {wh:docNo,doc:doc,itemlist:data}
    this.setState({loading:true})
    GenDocStore.saveWithholdingTaxDoc(postData,(result)=>{
      if (result.status==='OK') {
        doc.seq_no = result.seq_no
        this.setState({loading:false,doc:doc},()=>{
          completeSave()
        })
        this._notificationSystem.addNotification({
          title:messages['Notice'],
          message:messages['Save successfully'],
          level:'info',
          position:'tc'
        });        
      }
    },()=>{
      this.setState({loading:false})
      this._notificationSystem.addNotification({
        title:messages['Notice'],
        message:messages['Save fail'],
        level:'error',
        position:'tc'
      });
    })
  }

  onCloseClick(){
		if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }
  
  renderNewItemButton() {
    let {messages} = this.props
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
					<ButtonToolbar>
						<Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwsome name='plus'/>&nbsp;{messages['Add Item']}</Button>
          </ButtonToolbar>
				</Col>
      </Row>
    )
  }

  onPSelectHide() {
    this.setState({showPSelect:false,pSelect:'0'})
  }

  onPSelect() {
    let {pSelect} = this.state
    if (pSelect==='0') {
      this.setState({showSup:true})
    } else if (pSelect==='1') {
      this.setState({showEmp:true})
    } else if (pSelect==='2') {
      this.setState({showContractor:true})
    }
    this.onPSelectHide()
  }

  onPSelectChange(val) {
    let {pSelect} = this.state
    pSelect = val
    this.setState({pSelect:pSelect})
  }

  renderPSelectModal() {
    let {showPSelect,pSelect} = this.state
    let {messages} = this.props
    return(
        <div>
          <Modal show={showPSelect} onHide={this.onPSelectHide.bind(this)}>
            <Modal.Header closeButton>
              <Modal.Title>{messages['Select customer']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Radio
                  onChange={this.onPSelectChange.bind(this,'0')}
                  checked={pSelect==='0'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Supplier/store']}
                >
                </Radio>
                {' '}
                <Radio
                  onChange={this.onPSelectChange.bind(this,'1')}
                  checked={pSelect==='1'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Employee']}
                >
                </Radio>
                {' '}
                <Radio
                  onChange={this.onPSelectChange.bind(this,'2')}
                  checked={pSelect==='2'?true:false}
                  radioClass="iradio_square-blue"
                  increaseArea="20%"
                  label={' '+messages['Contractor']}
                >
                </Radio>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button bsStyle='primary' onClick={this.onPSelect.bind(this)}><FontAwsome name='thumbs-up'/>&nbsp;{messages['Select']}</Button>
              <Button onClick={this.onPSelectHide.bind(this)}><FontAwsome name='close'/>&nbsp;{messages['Close']}</Button>    
            </Modal.Footer>
          </Modal>
        </div>
    )
  }

  render() {
    let {loading,doc} = this.state
    let {messages} = this.props
  	return(
  		  <div>
  			  <Box loading={loading}>
						<Box.Header  className='text-center'>
							<Box.Title>
								{this.props.title} {messages['No.']} {this.state.docNo}              
							</Box.Title>
							<Box.Tools className='pull-right'>
								<Button className="bg-maroon btn" onClick={this.onPrintClick.bind(this)}><FontAwsome name='print' />&nbsp;{messages['Print Document']}</Button>
							</Box.Tools> 
						</Box.Header>
						<Box.Body>
              {this.renderHeaderRow()}
              <Form inline style={{marginBottom:'5px'}}>
                <FormGroup>
                  {messages['Form']} :
                </FormGroup>  
                {' '}
                <FormGroup>
                  <Select
                    placeholder={messages['Select']}
                    clearable={true}
                    value={doc.form_id}
                    options={this.state.form_options}
                    onChange={this.onFormChange.bind(this)}
                    style={{width:'200px'}}
                    clearValueText=''
                  />
                </FormGroup>  
              </Form>  
              {this.renderTable()}
              {this.renderNewItemButton()}
              {this.renderPayer()}
              <br />
							<Row>
                {this.renderRemark()}
                {false && this.renderOtherDetail()}
							</Row>	
            </Box.Body>
            <Box.Footer>
              <ButtonToolbar className='pull-right'>
                <Button bsStyle='primary' onClick={this.onSaveClick.bind(this,()=>{})}><FontAwsome name='save' />&nbsp;{messages['Save']}</Button>
								<Button onClick={this.onCloseClick.bind(this)}><FontAwsome name='close' />&nbsp;{messages['Close']}</Button>
              </ButtonToolbar>
            </Box.Footer>
          </Box>    
          <SupplierPageModal
            show={this.state.showSup}
            onHide={()=>{this.setState({showSup:false})}}
            onSelect={this.onSupSelect.bind(this)}
          />
          <NewContractorModal 
            show={this.state.showContractor} 
            onSelect={this.onContractorSelect.bind(this)} 
            onHide={()=>{this.setState({showContractor:false})}}
          />
          <EmployeeModal 
            show={this.state.showEmp} 
            onSelect={this.onEmployeeSelect.bind(this)} 
            onHide={()=>{this.setState({showEmp:false})}}
          />
          <NotificationSystem ref="notificationSystem" />
          {this.renderPSelectModal()}
          <IframeModal ref='iframePrint' title={messages['Print Document']} />
  		  </div>
  	)
  }
}
WithholdingTaxDoc.defaultProps = {
  title: ''
}
export default WithholdingTaxDoc = connect(
  (state) => ({messages: state.message.view.doc.WithholdingTaxDoc}),null,null,{withRef:true}
)(WithholdingTaxDoc);



// WEBPACK FOOTER //
// ./src/view/doc/WithholdingTaxDoc.js